<template>
  <div>
    <span
      v-if="showDropdown"
      class="dropdown-container"
    >
      <dropdown
        :closeOnClickInside="false"
        :classes="{ 'transaction-dropdown': true }"
        :containerClasses="dropdownContainerClass"
      >
        <div
          class="Fuell-Dropdown--toggle-switch"
          v-if="((canReviewOrLockTransaction || userCanLockTransaction) && !transactionIsAccounted)"
        >
          <span class="icon">
            <img
              :src="require('@/assets/img/icons/icon-lock.svg')"
              alt="Mark as locked"
            />
          </span>
          <span class="label">
            {{ $t('transactions_transaction_edit_lock_transaction') }}
          </span>
          <toggle-switch
            updateOnChange
            @change="handleLockTransaction"
            :status="transactionLockedFlag"
            :label="''"
          ></toggle-switch>
        </div>
        <div
          v-if="(isAdmin || isBookKeeper) && (transactionIsApproved || transactionIsRejected || transactionIsPersonalExpense)"
          class="Fuell-Dropdown--toggle-switch"
        >
          <span class="icon">
            <img
              :src="require('@/assets/img/icons/funnel/account.svg')"
              alt=""
            >
          </span>
          <span
            class="label label--large not-receipt"
            v-t="{path: transaction.accountedAt ? 'transaction_discounting' : 'transaction_account'}"
            @click="accountTransaction"
          >
          </span>
        </div>
        <div
          v-if="(receipts.length === 0 || !receipts) && !transactionIsLocked && !transactionWithoutReceipt"
          class="Fuell-Dropdown--toggle-switch"
        >
          <span
            class="label label--large not-receipt"
            v-t="{path:'transaction_dont_have_receipt'}"
            @click="showNotReceiptModal"
          >
          </span>
        </div>
        <div
          class="Fuell-Dropdown--toggle-switch mt-2 mb-3"
          v-if="showDontSendToDevoluivaButton"
        >
          <span class="icon--margin-text">
            <img
              :src="require('@/assets/img/icons/icon-receipt.svg')"
              alt="receipt"
            />
          </span>
          <span
            class="label label--large cp"
            v-t="{path:'transaction_dont_send_to_devoluiva'}"
          >
          </span>
          <toggle-switch
            updateOnChange
            @change="handleSendToDevoluiva"
            :status="sendToDevoluivaFlag"
            :label="''"
          ></toggle-switch>
        </div>
        <div
          class="Fuell-Dropdown--toggle-switch w-100"
          v-if="userCanRemoveExpense && !transactionIsLocked && !isProcessing"
        >

          <button
            class="Fuell-Button delete w-100 p-0"
            @click="deleteTransaction"
          >
            <span
              class="label w-100 text-left"
              v-t="{path: deleteText}"
            >
            </span>
          </button>
          <div></div>
        </div>
      </dropdown>
    </span>
    <transaction-not-receipt-modal
      v-if="showNotReceiptModalFlag"
      :open.sync="showNotReceiptModalFlag"
      @emitNotReceiptReason="handleNotReceipt"
    ></transaction-not-receipt-modal>
  </div>
</template>

<script>
import Dropdown from '@/components/Commons/Dropdown'
import { REVIEW_STATUS } from '@/constants/reviewStatus'
import _transactionAndExpenseCommon from '../../_mixins/_transactionAndExpenseCommon'
import ToggleSwitch from '@/components/Commons/Forms/ToggleSwitch'
const TransactionNotReceiptModal = () => import('../_shared/TransactionNotReceiptModal')

export default {
  name: 'TransactionsDropdown',
  mixins: [_transactionAndExpenseCommon],
  components: {
    Dropdown,
    ToggleSwitch,
    TransactionNotReceiptModal
  },
  props: {
    deleteText: {
      type: String,
      default: 'transaction_delete_expense'
    }
  },
  data () {
    return {
      showNotReceiptModalFlag: false
    }
  },
  computed: {
    transactionIsApproved () {
      return this.transaction.reviewStatus.code === REVIEW_STATUS.APPROVED
    },
    transactionIsRejected () {
      return this.transaction.reviewStatus.code === REVIEW_STATUS.CANCELLED
    },
    transactionIsPersonalExpense () {
      return this.transaction.isPersonalExpense
    },
    REVIEW_STATUS () {
      return REVIEW_STATUS
    },
    transactionLockedFlag () {
      return !!(
        (this.transaction?.lockedAt !== null && this.transaction?.lockedAt !== undefined) ||
        this.transaction?.receipt?.accountingPeriod
      )
    },
    isExpense () {
      return this.transactionType === 'EXPENSE'
    },
    isRegular () {
      return this.$store.getters['LoginStore/isUser']
    },
    dropdownContainerClass () {
      return this.showDontSendToDevoluivaButton
        ? 'Fuell-Dropdown--container--large'
        : ''
    },
    showDropdown () {
      if (!this.transaction.id) return false
      return (this.isAdmin || this.isBookKeeper || this.isRegular) && !this.transactionIsAccounted && ((this.canReviewOrLockTransaction || this.userCanLockTransaction) || this.showDontSendToDevoluivaButton || (this.userCanRemoveExpense && !this.transactionIsLocked && !this.isProcessing))
    },
    showDontSendToDevoluivaButton () {
      if (this.userHasDevoluiva && !this.isExpense) {
        return this.transaction && this.transaction.receipt && this.transaction.receiptMedia?.length > 0
          ? !this.transaction.receipt.isSentDevoluiva
          : false
      } else {
        return false
      }
    },
    canReviewOrLockTransaction () {
      if (this.isExpense) {
        return this.isAdmin || this.isBookKeeper
      }
      if (this.isUser && this.userIsOwnerOfBudget) {
        return true
      }
      if (this.isAdmin || this.isBookKeeper) {
        return true
      }

      return false
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    userIsOwnerOfBudget () {
      return this.transaction && this.transaction.budget
        ? this.transaction.budget.imOwner
        : false
    }
  },
  methods: {
    async accountTransaction () {
      try {
        if (!this.transaction.accountedAt) {
          this.$store.dispatch('TransactionsStore/accountTransaction', this.transaction.id)
        } else {
          this.$store.dispatch('TransactionsStore/unaccountTransaction', this.transaction.id)
        }
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transaction_accounted_error' }, { root: true })
      }
    },
    showNotReceiptModal () {
      this.showNotReceiptModalFlag = !this.showNotReceiptModalFlag
    },
    async handleNotReceipt (reason) {
      this.showNotReceiptModalFlag = !this.showNotReceiptModalFlag
      try {
        const sendData = {
          id: this.transaction.id,
          withoutTicket: true,
          withoutTicketNotes: reason
        }
        this.$store.dispatch('TransactionsStore/editTransaction', { transactionInformation: sendData, originalTransaction: this.transaction })
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transaction_dont_send_to_devoluiva_error' }, { root: true })
        // Revert change
        this.sendToDevoluivaFlag = !this.sendToDevoluivaFlag
      }
    },
    async handleSendToDevoluiva () {
      this.sendToDevoluivaFlag = !this.sendToDevoluivaFlag
      try {
        const sendData = {
          id: this.transaction.id,
          receipt: {
            id: this.transaction.receipt.id,
            doNotSendDevoluiva: this.sendToDevoluivaFlag
          }
        }
        this.$store.dispatch('TransactionsStore/editTransaction', { transactionInformation: sendData, originalTransaction: this.transaction })
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transaction_dont_send_to_devoluiva_error' }, { root: true })
        // Revert change
        this.sendToDevoluivaFlag = !this.sendToDevoluivaFlag
      }
    }
  }
}
</script>
<style lang="scss">
.Fuell-Dropdown--container--large {
  height: auto;
  max-width: 325px;
  width: 310px;
}
.Fuell-Dropdown--container--large .label {
  text-align: left;
  margin-left: 5px;
  white-space: normal !important;
}
.not-receipt {
  text-align: left;
  cursor: pointer;
}
</style>
